function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "nonzero",
  d: "M9.149 0H1.005C.458 0 .013.468.013 1.042v14.901c0 .575.445 1.042.992 1.042h9.976c.547 0 .992-.467.992-1.042V3.221L9.149 0zm.234 1.559l1.238 1.412H9.383V1.559zm1.756 14.384a.164.164 0 0 1-.159.167H1.005a.163.163 0 0 1-.159-.167V1.042c0-.092.072-.167.16-.167h7.543v2.533c0 .241.188.437.417.437h2.173v12.098zM2.316 4.653h7.076a.32.32 0 0 1 .312.327.32.32 0 0 1-.312.327H2.316a.32.32 0 0 1-.312-.327c0-.181.14-.328.312-.328zm7.388 2.529a.32.32 0 0 1-.312.328H2.316a.32.32 0 0 1-.312-.328c0-.181.14-.328.312-.328h7.076a.32.32 0 0 1 .312.328zm0 2.13a.32.32 0 0 1-.312.328H2.316a.32.32 0 0 1-.312-.328c0-.181.14-.328.312-.328h7.076a.32.32 0 0 1 .312.328zm0 2.166a.32.32 0 0 1-.312.328H2.316a.32.32 0 0 1-.312-.328c0-.18.14-.328.312-.328h7.076a.32.32 0 0 1 .312.328z"
});

var SvgDocuments = function SvgDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documents.227662c1.svg";
export { ForwardRef as ReactComponent };